export default "__VITE_ASSET__BuIrB_Qo__"